<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0" cols="12" id="head_title">
			<v-col class="pa-0" cols="12" id="main_content_maxwidthset">
				<v-row class="ma-0 pa-0" align="center" id="header_height">
					<v-row class="ma-0 pa-0" align="center">
						<v-col class="ma-0 pa-0" cols="auto">
							<v-btn id="back_clean_btn" width="2rem" height="50px"
								class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
								@click="goSetting">
								{{ts('title')}}
							</v-btn>
						</v-col>
						<v-img max-height="50px" max-width="1.5rem" class="ma-0 pa-0 mr-3"
							src="@/assets/images/history_arrow.png"></v-img>
						<v-col class="ma-0 pa-0" cols="auto">
							{{ts('notificationSetting')}}
						</v-col>
					</v-row>
					<v-row class="ma-0 pa-0" align="center" justify="end">
						<v-col class="ma-0 pa-0" cols="auto"
							v-if="role == 'main' || role == 'head'">
							<v-btn id="blue_btn" width="10rem" height="2rem"
								class="ma-0 pa-0" elevation="0" style="font-size:0.9rem;" @click="groupEditDialogClick">
								{{t('storeConditions')}}
							</v-btn>
						</v-col>
						<v-col class="ma-0 pa-0 ml-12 mr-2" cols="auto">
							<v-btn id="grey_btn" width="9rem" height="2rem"
								class="ma-0 pa-0" elevation="0" style="font-size:0.9rem;"
                @click="requestReset" :loading="resetLoading">
								{{t('reset')}}
							</v-btn>
						</v-col>
						<v-col class="ma-0 pa-0" cols="auto">
							<v-btn id="blue_btn" width="9rem" height="2rem"
								class="ma-0 pa-0" elevation="0" style="font-size:0.9rem;"
                @click="pushSetting(false)" :loading="requestLoading">
								{{ts('save')}}
							</v-btn>
						</v-col>
					</v-row>
				</v-row>
			</v-col>
		</v-col>

    <v-row class="ma-0 pa-0">
      <v-col class="ma-0 pa-0 mt-2 pb-1" cols="12" id="search_result">
        <v-row class="ma-0 pa-0 ml-13 mr-8" justify="space-between" align="center">
          <v-col class="ma-0 pa-0" cols="auto">{{tl('filteringResult')}}</v-col>
          <v-col class="ma-0 pa-0" cols="auto">
            <v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3" 
							id="back_clean_btn" elevation="0" @click="deleteSearchResult()">
							<v-row class="ma-0 pa-0" align="center" style="color:white;">
								<v-img max-height="1.5rem" max-width="1.5rem" class="ma-0 pa-0 mr-2"
									src="@/assets/images/close_grey.png"></v-img>
                  {{tl('cancelSearch')}}
							</v-row>
						</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-col class="pa-0" id="main_content_maxwidthset" cols="12" align="center">
			<template v-if="fetchLoading == false">
				<v-col class="ma-0 pa-0 pt-9 mb-15" cols="10">
					<v-row id="title_font" class="ma-0 pa-0 mb-2" align="center">
						<v-col class="ma-0 pa-0" cols="4">
							<!-- {{ts('receiveNotificationOfDisconnection')}} -->
						</v-col>
						<v-col class="ma-0 pa-0 pl-14" cols="4" align="left">
							{{ts('motionDetectionNotification')}}
						</v-col>
						<v-col class="ma-0 pa-0 pl-14" cols="4" align="left">
							{{ts('soundDetectionNotification')}}
						</v-col>
					</v-row>
					<v-row id="title_font" class="ma-0 pa-0" align="center"
						style="color:#8E8E8E;">
						<v-col class="ma-0 pa-0 pr-3" cols="4">
							<v-row class="ma-0 pa-0" align="center">
								<v-col class="ma-0 pa-0" cols="7">
									{{ts('cameraName')}}
								</v-col>
								<!-- <v-col class="ma-0 pa-0" cols="4">
									{{ts('pushNotification')}}
								</v-col> -->
								<v-col class="ma-0 pa-0 pl-7" cols="4">
									<!-- {{ts('emailNotification')}} -->
								</v-col>
							</v-row>
						</v-col>
						<v-col class="ma-0 pa-0 pl-3 pr-3" cols="4">
							<v-row class="ma-0 pa-0" align="center">
								<!-- <v-col class="ma-0 pa-0" cols="4">
									{{ts('pushNotification')}}
								</v-col> -->
								<v-col class="ma-0 pa-0" cols="3">
									{{ts('emailNotification')}}
								</v-col>
								<v-col class="ma-0 pa-0" cols="5">
									{{ts('scheduleSettings')}}
								</v-col>
							</v-row>
						</v-col>
						<v-col class="ma-0 pa-0 pl-3" cols="4">
							<v-row class="ma-0 pa-0" align="center">
								<!-- <v-col class="ma-0 pa-0" cols="4">
									{{ts('pushNotification')}}
								</v-col> -->
								<v-col class="ma-0 pa-0" cols="3">
									{{ts('emailNotification')}}
								</v-col>
								<v-col class="ma-0 pa-0" cols="5">
									{{ts('scheduleSettings')}}
								</v-col>
							</v-row>
						</v-col>
					</v-row>

					<template v-if="storeList.length > 0">
						<v-row class="ma-0 pa-0 pt-2 pb-2" align="center"
							v-if="role == 'main' || role == 'head'">
							<v-col class="ma-0 pa-0 pr-3" cols="4">
								<v-row class="ma-0 pa-0" align="center">
									<v-col class="ma-0 pa-0" cols="7">
										{{ts('allStore')}}
									</v-col>
									<!-- <v-col class="ma-0 pa-0" cols="4" align="center">
										<v-col class="ma-0 pa-0" cols="3">
											<input id="check_box" type="checkbox" 
												v-model="allStore.disconnectedPush" />
										</v-col>
									</v-col> -->
									<v-col class="ma-0 pa-0 pl-7" cols="4" align="center">
										<v-col class="ma-0 pa-0" cols="3">
											<!-- <input id="check_box" type="checkbox" 
												v-model="allStore.disconnectedEmail" /> -->
										</v-col>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0 pl-3 pr-3" cols="4">
								<v-row class="ma-0 pa-0" align="center">
									<!-- <v-col class="ma-0 pa-0" cols="4" align="center">
										<v-col class="ma-0 pa-0" cols="3">
											<input id="check_box" type="checkbox" 
												v-model="allStore.motionDetectPush" />
										</v-col>
									</v-col> -->
									<v-col class="ma-0 pa-0" cols="3" align="center">
										<v-col class="ma-0 pa-0" cols="3">
											<input id="check_box" type="checkbox" 
												v-model="allStore.motionDetectEmail" />
										</v-col>
									</v-col>
									<v-col class="ma-0 pa-0" cols="5">
										<v-btn width="auto" height="auto" class="ma-0 pa-1" 
											id="back_clean_btn" elevation="0"
											@click="cameraScheduleSetting('motionAll', null, null)">
											<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
												src="@/assets/images/icon_setting.png"></v-img>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
							<v-col class="ma-0 pa-0 pl-3" cols="4">
								<v-row class="ma-0 pa-0" align="center">
									<!-- <v-col class="ma-0 pa-0" cols="4" align="center">
										<v-col class="ma-0 pa-0" cols="3">
											<input id="check_box" type="checkbox" 
												v-model="allStore.soundDetectPush" />
										</v-col>
									</v-col> -->
									<v-col class="ma-0 pa-0" cols="3" align="center">
										<v-col class="ma-0 pa-0" cols="3">
											<input id="check_box" type="checkbox" 
												v-model="allStore.soundDetectEmail" />
										</v-col>
									</v-col>
									<v-col class="ma-0 pa-0" cols="5">
										<v-btn width="auto" height="auto" class="ma-0 pa-1" 
											id="back_clean_btn" elevation="0"
											@click="cameraScheduleSetting('soundAll', null, null)">
											<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
												src="@/assets/images/icon_setting.png"></v-img>
										</v-btn>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
					</template>
					<template v-else>
						<v-col class="ma-0 pa-12" cols="12">
							{{t('noData')}}
						</v-col>
					</template>
					<v-col class="ma-0 pa-0" cols="auto">
            <v-col class="ma-0 pa-0" v-for="(store, index) in groupList" :key="index">
							<v-row class="ma-0 pa-0 pt-2 pb-2" align="center" style="border-bottom: 1px solid #3d3d3d;">
								<v-col class="ma-0 pa-0 pr-3" cols="4">
									<v-row class="ma-0 pa-0" align="center">
                    <v-btn class="ma-0 pa-0 mr-1 toggle_btn" @click="listToggle(index)" elevation="0" color="white">
                      <v-icon :id="'toggle_btn_icon_' + index">
                        mdi-menu-up
                      </v-icon>
                      <!-- <img class="ma-0 pa-0 toggle_down" :id="'toggle_btn_img_' + index" src="@/assets/images/icon_arrow_down_small.png" /> -->
                      <!-- <v-img class="ma-0 pa-0 toggle_up" style="display: none;" :id="'toggle_up_img_' + index" src="@/assets/images/icon_arrow_up_small.png"></v-img> -->
                    </v-btn>
										<v-col class="ma-0 pa-0 detail_group" cols="7">
											{{store.name | nameLengthFormat}}
										</v-col>
										<!-- <v-col class="ma-0 pa-0 pr-6" cols="4" align="center">
											<v-col class="ma-0 pa-0" cols="3">
												<input id="check_box" type="checkbox" 
													@click="checkAll(store.name, 'allDisconnectedPush', !store.allDisconnectedPush)"
													v-model="store.allDisconnectedPush" />
											</v-col>
										</v-col> -->
										<v-col class="ma-0 pa-0 pl-5" cols="4" align="center">
											<v-col class="ma-0 pa-0" cols="3">
												<!-- <input id="check_box" type="checkbox"
													@click="checkAll(store.contractCd, 'allDisconnectedEmail', !store.allDisconnectedEmail)"
													v-model="store.allDisconnectedEmail" /> -->
											</v-col>
										</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0 pl-3 pr-3" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<!-- <v-col class="ma-0 pa-0 pr-8" cols="3" align="center">
											<v-col class="ma-0 pa-0" cols="4">
												<input id="check_box" type="checkbox"
													@click="checkAll(store.name, 'allMotionDetectPush', !store.allMotionDetectPush)"
													v-model="store.allMotionDetectPush" />
											</v-col>
										</v-col> -->
										<v-col class="ma-0 pa-0" cols="3" align="center">
											<v-col class="ma-0 pa-0" cols="3">
												<input id="check_box" type="checkbox"
													@click="checkAll(store.unisCustomerCd, 'allMotionDetectEmail', !store.allMotionDetectEmail)"
													v-model="store.allMotionDetectEmail" />
											</v-col>
										</v-col>
										<v-col class="ma-0 pa-0" cols="5">
											<v-btn width="auto" height="auto" class="ma-0 pa-1" v-if="store.allMotionDetectEmail"
												id="back_clean_btn" elevation="0" 
												@click="cameraScheduleSetting('motionAll', store, null)">
												<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
													src="@/assets/images/icon_setting.png"></v-img>
											</v-btn>
                      <v-btn width="auto" height="auto" class="ma-0 pa-1" v-else diabled elevation="0" id="back_clean_btn">
                        <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0" style="opacity: 0.3"
										  		src="@/assets/images/icon_setting.png"></v-img>
                      </v-btn>
										</v-col>
									</v-row>
								</v-col>
								<v-col class="ma-0 pa-0 pl-3" cols="4">
									<v-row class="ma-0 pa-0" align="center">
										<!-- <v-col class="ma-0 pa-0 pr-4" cols="4" align="center">
											<v-col class="ma-0 pa-0" cols="3">
												<input id="check_box" type="checkbox"
													@click="checkAll(store.name, 'allSoundDetectPush', !store.allSoundDetectPush)"
													v-model="store.allSoundDetectPush" />
											</v-col>
										</v-col> -->
										<v-col class="ma-0 pa-0" cols="3" align="center">
											<v-col class="ma-0 pa-0" cols="3">
												<input id="check_box" type="checkbox"
													@click="checkAll(store.unisCustomerCd, 'allSoundDetectEmail', !store.allSoundDetectEmail)"
													v-model="store.allSoundDetectEmail" />
											</v-col>
										</v-col>
										<v-col class="ma-0 pa-0" cols="5">
											<v-btn width="auto" height="auto" class="ma-0 pa-1" v-if="store.allSoundDetectEmail"
												id="back_clean_btn" elevation="0" 
												@click="cameraScheduleSetting('soundAll', store, null)">
												<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
													src="@/assets/images/icon_setting.png"></v-img>
											</v-btn>
                      <v-btn width="auto" height="auto" class="ma-0 pa-1" v-else diabled elevation="0" id="back_clean_btn">
                        <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0" style="opacity: 0.3"
										  		src="@/assets/images/icon_setting.png"></v-img>
                      </v-btn>
										</v-col>
									</v-row>
								</v-col>
							</v-row>
              <v-col :id="'status_list_item_' + index" class="ma-0 pa-0 list_items" style="display: block;">
                <v-col class="ma-0 pa-0" v-for="(detail, index_camera) in store.cameraList" :key="index_camera">
      	          <v-row class="ma-0 pa-0 pt-2 pb-2 status_border" align="center">
										<v-col class="ma-0 pa-0 pr-3" cols="4">
										  <v-row class="ma-0 pa-0 pl-10" align="center">
										  	<v-col class="ma-0 pa-0 detail_group" cols="7">
										  		{{detail.cameraName | nameLengthFormat}}
										  	</v-col>
										  	<!-- <v-col class="ma-0 pa-0" cols="4" align="center">
										  		<v-col class="ma-0 pa-0" cols="3">
										  			<input id="check_box" type="checkbox" 
										  				v-model="detail.unPlugPushAlert" />
										  		</v-col>
										  	</v-col> -->
										  	<v-col class="ma-0 pa-0 pl-7" cols="4" align="center">
										  		<v-col class="ma-0 pa-0" cols="3">
										  			<!-- <input id="check_box" type="checkbox" 
										  				v-model="detail.unPlugMailAlert" /> -->
										  		</v-col>
										  	</v-col>
										  </v-row>
										</v-col>
										<v-col class="ma-0 pa-0 pl-3 pr-3" cols="4">
											<v-row class="ma-0 pa-0" align="center">
												<!-- <v-col class="ma-0 pa-0" cols="4" align="center">
													<v-col class="ma-0 pa-0" cols="3">
														<input id="check_box" type="checkbox" 
															v-model="detail.motionDetectPushAlert" />
													</v-col>
												</v-col> -->
												<v-col class="ma-0 pa-0" cols="3" align="center">
													<v-col class="ma-0 pa-0" cols="3">
														<input id="check_box" type="checkbox" 
															v-model="detail.motionDetectMailAlert" />
													</v-col>
												</v-col>
												<v-col class="ma-0 pa-0" cols="5">
													<v-btn width="auto" height="auto" class="ma-0 pa-1" v-if="detail.motionDetectMailAlert"
														id="back_clean_btn" elevation="0" 
														@click="cameraScheduleSetting('motion', null, detail)">
														<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
															src="@/assets/images/icon_setting.png"></v-img>
													</v-btn>
                          <v-btn width="auto" height="auto" class="ma-0 pa-1" v-else diabled elevation="0" id="back_clean_btn">
                            <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0" style="opacity: 0.3"
															src="@/assets/images/icon_setting.png"></v-img>
                          </v-btn>
												</v-col>
											</v-row>
										</v-col>
										<v-col class="ma-0 pa-0 pl-3" cols="4">
											<v-row class="ma-0 pa-0" align="center">
											  <!-- <v-col class="ma-0 pa-0" cols="4" align="center">
											  	<v-col class="ma-0 pa-0" cols="3">
											  		<input id="check_box" type="checkbox" 
											  			v-model="detail.soundDetectPushAlert" />
											  	</v-col>
											  </v-col> -->
											  <v-col class="ma-0 pa-0" cols="3" align="center">
											  	<v-col class="ma-0 pa-0" cols="3">
											  		<input id="check_box" type="checkbox" 
											  			v-model="detail.soundDetectMailAlert" />
											  	</v-col>
											  </v-col>
											  <v-col class="ma-0 pa-0" cols="5">
											    <v-btn width="auto" height="auto" class="ma-0 pa-1" v-if="detail.soundDetectMailAlert"
											    	id="back_clean_btn" elevation="0" 
											    	@click="cameraScheduleSetting('sound', null, detail)">
											    	<v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0"
											    		src="@/assets/images/icon_setting.png"></v-img>
											    </v-btn>
                          <v-btn width="auto" height="auto" class="ma-0 pa-1" v-else diabled elevation="0" id="back_clean_btn">
                            <v-img max-height="1.25rem" max-width="1.25rem" class="ma-0 pa-0" style="opacity: 0.3"
											    		src="@/assets/images/icon_setting.png"></v-img>
                          </v-btn>
											  </v-col>
											</v-row>
										</v-col>
									</v-row>
                </v-col>
              </v-col>
            </v-col>
          </v-col>

				</v-col>
			</template>
			<template v-else>
        <v-col class="ma-0 pa-15 mt-10 mb-10" cols="10">
          <v-progress-circular indeterminate color="white"
						:width="4" :size="40"></v-progress-circular>
        </v-col>
      </template>
			<TimeSettingDialog :dialogVisible="timeSettingDialogVisible"
				:selectedCamera="selectedCamera" @makeParams="makeTimeParamsFunc"
				@visible="timeSettingDialogVisibleFunc" />
		  <GroupEditDialog :dialogVisible="groupEditDialogVisible" 
				:fromHeader="false" :fromNoti="true" :notiStoreList="groupList"
        @visible="groupEditDialogVisibleFunc" @selectedStores="selectedStoresFunc"/>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import TimeSettingDialog from '@/components/dialogs/TimeSettingDialog.vue';
import GroupEditDialog from '@/components/dialogs/GroupEditDialog.vue';
import $ from 'jquery';
import 'jquery-ui-dist/jquery-ui';
import cloneDeep from 'lodash/cloneDeep';
// import { testNotificationSettingData } from '../whitetest/sampleData';
export default {
	components: {
		TimeSettingDialog, GroupEditDialog
	},
	mixins: [mixin.common],
	data: () => ({
		timeSettingDialogVisible: false,
    groupEditDialogVisible: false,
		fetchLoading: false,
    role: '',
		childrenCheck: false,
		allStore: {
			disconnectedPush: false,
			disconnectedEmail: false,
			motionDetectPush: false,
			motionDetectEmail: false,
			soundDetectPush: false,
			soundDetectEmail: false,
		},
		// storeList: testNotificationSettingData,
    storeList: [],
    groupList: [],
    testList: [],
		selectedCamera: {},
		requestLoading: false,
    resetLoading: false,
    resetValue: [true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true, true],
		searchResultStatus: false,
		AllStoreAlertScheduleSetting: {
			motion: undefined,
			sound: undefined,
		},
		selectedStoreAlertScheduleSetting: {
			motion: undefined,
			sound: undefined,
		},
	}),
	watch: {
		'allStore.disconnectedPush': function(val) {
			if(this.childrenCheck == false) {
				this.groupList.forEach((store) => {
					store.allDisconnectedPush = val;
					store.cameraList.forEach((camera) => {
						camera.unPlugPushAlert = val;
					});
				});
			}
		},
		'allStore.disconnectedEmail': function(val) {
			if(this.childrenCheck == false) {
				this.groupList.forEach((store) => {
					store.allDisconnectedEmail = val;
					store.cameraList.forEach((camera) => {
						camera.unPlugMailAlert = val;
					});
				});
			}
		},
		'allStore.motionDetectPush': function(val) {
			if(this.childrenCheck == false) {
				this.groupList.forEach((store) => {
					store.allMotionDetectPush = val;
					store.cameraList.forEach((camera) => {
						camera.motionDetectPushAlert = val;
					});
				});
			}
		},
		'allStore.motionDetectEmail': function(val) {
			if(this.childrenCheck == false) {
				this.groupList.forEach((store) => {
					store.allMotionDetectEmail = val;
					store.cameraList.forEach((camera) => {
						camera.motionDetectMailAlert = val;
					});
				});
			}
		},
		'allStore.soundDetectPush': function(val) {
			if(this.childrenCheck == false) {
				this.groupList.forEach((store) => {
					store.allSoundDetectPush = val;
					store.cameraList.forEach((camera) => {
						camera.soundDetectPushAlert = val;
					});
				});
			}
		},
		'allStore.soundDetectEmail': function(val) {
			if(this.childrenCheck == false) {
				this.groupList.forEach((store) => {
					store.allSoundDetectEmail = val;
					store.cameraList.forEach((camera) => {
						camera.soundDetectMailAlert = val;
					});
				});
			}
		},
	},
	filters: {
		nameLengthFormat: function(str) {
			if(str != undefined) {
				if(str.length < 14) {
					return str;
				} else if(str.length > 13 && str.length < 25) {
					return str.substring(0,13) + '\n' + str.substring(13, 24);
				} else if(str.length > 24 && str.length < 36) {
					return str.substring(0,13) + '\n' + str.substring(13, 24) + '\n' + str.substring(24, 35);
				} else if(str.length > 35) {
					return str.substring(0,13) + '\n' + str.substring(13, 24) + '\n' + str.substring(24, 35) + '\n' + str.substring(35, 46);
				}
			} else {
				return '';
			}
		}
	},
	mounted() {
		this.role = this.roleCheck(this.$store.getters.getRole);
		this.fetchSettingData();
	},
	methods: {
		ts(t) {
      return this.$t("lang.settings." + t);
    },
		tl(t) {
      return this.$t("lang.log." + t);
		},
		goSetting() {
			const role = this.roleCheck(this.$store.getters.getRole);
			if(role == 'private' || role == 'branch') this.replaceRoute('/private/setting', {});
			else this.replaceRoute('/setting', {});
		},
		groupEditDialogClick() {
			if(this.searchResultStatus) {
				this.deleteSearchResult();
			}
			this.groupEditDialogVisible = true;
		},
		timeSettingDialogVisibleFunc(visible) {
			this.timeSettingDialogVisible = visible;
		},
    groupEditDialogVisibleFunc(visible) {
      this.groupEditDialogVisible = visible;
    },
    selectedStoresFunc(stores) {
      if(stores.length != 0) {
        //점포명 기반 리스트 수정
        let resultArr = [];
        stores.forEach((item) => { //groupList에 있는 점포명인 경우만 남기기
          let index = this.groupList.findIndex(r => r.name == item.customerName);
          if(index != -1) {
            resultArr.push(this.groupList[index]);
          }
        });

        this.groupList = resultArr;

        this.searchResult();
      }
    },
		async checkAll(unisCustomerCd, setting, value) {
			this.childrenCheck = await true;
			this.storeList.forEach((store) => {
				if(store.unisCustomerCd == unisCustomerCd) {
					if(value) {
						switch (setting) {
							case 'allDisconnectedPush':
								store.unPlugPushAlert = value;
								break;
							case 'allDisconnectedEmail':
								store.unPlugMailAlert = value;
								break;
							case 'allMotionDetectPush':
								store.motionDetectPushAlert = value;
								break;
							case 'allMotionDetectEmail':
								store.motionDetectMailAlert = value;
								break;
							case 'allSoundDetectPush':
								store.soundDetectPushAlert = value;
								break;
							default:
								store.soundDetectMailAlert = value;
								break;
						}
					} else {
						switch (setting) {
							case 'allDisconnectedPush':
								this.allStore.disconnectedPush = false;
								store.unPlugPushAlert = value;
								break;
							case 'allDisconnectedEmail':
								this.allStore.disconnectedEmail = false;
								store.unPlugMailAlert = value;
								break;
							case 'allMotionDetectPush':
								this.allStore.motionDetectPush = false;
								store.motionDetectPushAlert = value;
								break;
							case 'allMotionDetectEmail':
								this.allStore.motionDetectEmail = false;
								store.motionDetectMailAlert = value;
								break;
							case 'allSoundDetectPush':
								this.allStore.soundDetectPush = false;
								store.soundDetectPushAlert = value;
								break;
							default:
								this.allStore.soundDetectEmail = false;
								store.soundDetectMailAlert = value;
								break;
						}
					}
				}
			});
			this.childrenCheck = await false;
		},
		fetchSettingData() {
			this.fetchLoading = true;
			let params = {};
      this.networkController.getNotificationSettingData(params)
      .then(async (res) => {
				console.log('%cNotification Setting Data\n', "color:#008DD0;", res.data);
        this.storeList = res.data;
        this.toGroupList();
      }).catch(() => {
				this.fetchLoading = false;
			});
		},
    toGroupList() {
			this.groupList = [];
      let listGroupBy = this.storeList.reduce(function (array, el) {
        var group = el['unisCustomerCd'];
        if (array[group] === undefined) {
          array[group] = []
        }
        array[group].push(el)
        return array;
      }, {});
      for(var key in listGroupBy) {
        let unPlugEmailCheck = true;
        let unPlugPushCheck = true;
        let motionEmailCheck = true;
        let motionPushCheck = true;
        let soundEmailCheck = true;
        let soundPushCheck = true;
        //자식 노드의 체크박스가 모두 체크된 경우 부모 노드도 체크
        listGroupBy[key].forEach((item) => {
          if(item.unPlugPushAlert == false)
            unPlugPushCheck = false;
          if(item.unPlugMailAlert == false)
            unPlugEmailCheck = false;
          if(item.motionDetectPushAlert == false)
            motionPushCheck = false;
          if(item.motionDetectMailAlert == false)
            motionEmailCheck = false;
          if(item.soundDetectPushAlert == false)
            soundPushCheck = false;
          if(item.soundDetectMailAlert == false)
            soundEmailCheck = false;
        })
        this.groupList.push({
          'name': listGroupBy[key][0].customerName,
					'unisCustomerCd': key,
          'allDisconnectedPush:': unPlugPushCheck,
          'allDisconnectedEmail': unPlugEmailCheck,
          'allMotionDetectPush': motionPushCheck,
          'allMotionDetectEmail': motionEmailCheck,
          'allSoundDetectPush': soundPushCheck,
          'allSoundDetectEmail': soundEmailCheck,
          'contractCd': listGroupBy[key][0].contractCd,
          'cameraList': listGroupBy[key],
        });
      }
			this.fetchLoading = false;
      console.log(this.groupList);
    },
		cameraScheduleSetting(type, store, cameraDetail) {
			if(!store && !cameraDetail) { // 전점포 스케쥴 설정
				this.selectedCamera = {
					type: type,
          unisCustomerCd: '',
					portNo: '',
					alertScheduleSetting: type == 'motionAll' 
						? this.AllStoreAlertScheduleSetting.motion
						: this.AllStoreAlertScheduleSetting.sound,
				}
			} else if(cameraDetail == null) { // 매장 카메라전체를 설정할때
				this.selectedCamera = {
					type: type,
          unisCustomerCd: store.unisCustomerCd,
					portNo: '',
					alertScheduleSetting: type == 'motionAll' 
						? this.selectedStoreAlertScheduleSetting.motion
						: this.selectedStoreAlertScheduleSetting.sound,
				}
			} else if(cameraDetail != null) { // 매장의 단일 카메라를 설정할때
				if(type == 'motion') {
					this.selectedCamera = {
						type: type,
            unisCustomerCd: cameraDetail.unisCustomerCd,
						portNo: cameraDetail.portNo,
						alertScheduleSetting: cameraDetail.alertScheduleSetting.motion
					}
				} else {
					this.selectedCamera = {
						type: type,
            unisCustomerCd: cameraDetail.unisCustomerCd,
						portNo: cameraDetail.portNo,
						alertScheduleSetting: cameraDetail.alertScheduleSetting.sound
					}
				}
			}

			this.timeSettingDialogVisible = true;
		},
		makeTimeParamsFunc(data) {
			if(this.selectedCamera.type === 'motion' || this.selectedCamera.type === 'sound') {
				let index = this.storeList.findIndex(el => el.unisCustomerCd == this.selectedCamera.unisCustomerCd 
					&& el.portNo == this.selectedCamera.portNo);
				if(this.selectedCamera.type == 'motion') {
					this.storeList[index].alertScheduleSetting.motion = data.params;
				} else if(this.selectedCamera.type == 'sound') {
					this.storeList[index].alertScheduleSetting.sound = data.params;
				}
				this.toGroupList();
			} else if(this.selectedCamera.type === 'motionAll') {
				this.storeList.forEach((store) => {
					if(data.unisCustomerCd == '') { // 전점포 설정시
            const finalData = cloneDeep(data.params); //__ob__: Observer 삭제하여 데이터 복제되는것을 방지
						store.alertScheduleSetting.motion = finalData;
					} else {
						if(store.unisCustomerCd == data.unisCustomerCd) {
							const finalData = cloneDeep(data.params); //__ob__: Observer 삭제하여 데이터 복제되는것을 방지
							store.alertScheduleSetting.motion = finalData;
						}
					}
				});
				setTimeout(() => {
					this.toGroupList();
				}, 100);
			} else if(this.selectedCamera.type === 'soundAll') {
				this.storeList.forEach((store) => {
					if(data.unisCustomerCd == '') { // 전점포 설정시
            const finalData = cloneDeep(data.params);
						store.alertScheduleSetting.sound = finalData;
					} else {
						if(store.unisCustomerCd == data.unisCustomerCd) {
							const finalData = cloneDeep(data.params);
							store.alertScheduleSetting.sound = finalData;
						}
					}
				});
				setTimeout(() => {
					this.toGroupList();
				}, 100);
			}
		},
    pushSetting(reset) {
			if(reset == false){
        this.requestLoading = true;
      } else {
        this.resetLoading = true;
      }
      let params = this.storeList;
      this.networkController.pushNotificationSettingData(params)
      .then(async (res) => {
				this.storeList = res.data;
        this.toGroupList();
				this.showToastMessage(this.tmb(reset == false ? 'requestSuccess' : 'resetSuccess'));
			  if(reset == false){
          this.requestLoading = false;
        } else {
          this.resetLoading = false;
        }
				// this.goSetting();
      }).catch(() => {
				this.showToastMessage(this.tmb('requestFail'));
			  if(reset == false){
          this.requestLoading = false;
        } else {
          this.resetLoading = false;
        }
      });
    },
    searchResult() {
			this.searchResultStatus = true;
      $('#search_result').css({'display': 'block'});
    },
    deleteSearchResult() {
			this.searchResultStatus = false;
		  this.fetchSettingData();
      $('#search_result').css({'display': 'none'});
    },
		requestReset() {
			this.$dialog.confirm({
				title: this.ts('settingReset'),
				text: this.ts('askSettingReset'),
				actions: {
					false: { color: 'white', text: this.t('cancel'),},
					true: {
						color: 'white', text: this.t('reset2'),
						handle: () => {
              this.resetStoreList();
              // this.fetchSettingData();
						}
					}
				}
			});
		},
    resetStoreList() {
      this.storeList.forEach((item) => {
        item.alertScheduleSetting.motion.forEach((days) => {
          days.enable = true;
          days.value = this.resetValue;
        });
        item.alertScheduleSetting.sound.forEach((days) => {
          days.enable = true;
          days.value = this.resetValue;
        });
        item.motionDetectMailAlert = false;
        item.motionDetectPushAlert = false;
        item.soundDetectMailAlert = false;
        item.soundDetectPushAlert = false;
        item.unPlugMailAlert = false;
        item.unPlugPushAlert = false;
      });
			this.allStore.motionDetectEmail = false;
			this.allStore.soundDetectEmail = false;
      this.pushSetting(true);
    },
    listToggle(index) {
      if(document.getElementById("status_list_item_" + index).style.display == 'none') {
        document.getElementById("status_list_item_" + index).style.display = 'block';
        document.getElementById("toggle_btn_icon_" + index).classList.remove("mdi-menu-down");
        document.getElementById("toggle_btn_icon_" + index).classList.add("mdi-menu-up");
      }
      else {
        document.getElementById("status_list_item_" + index).style.display = 'none';
        document.getElementById("toggle_btn_icon_" + index).classList.remove("mdi-menu-up");
        document.getElementById("toggle_btn_icon_" + index).classList.add("mdi-menu-down");
      }
    }
	}
}
</script>

<style lang="scss" scoped>
#head_title {
	background-color: #272A33;
  position: sticky;
	top: 0;
	z-index: 5;
}
#header_body {
	height: 50px;
}
#header_text {
  font-size: 1rem;
  text-align: left;
}
.sticky_body {
	height: calc(100vh - 50px);
}
#title_font {
	font-size: 0.8rem;
}
#status_list {
  background: transparent;
  border: none;
}
.detail_group {
	text-align: left;
	color: white;
}
.detail_list{
  border-top: 1px solid #333740;
	color: white;
}
::v-deep {
  .v-treeview-node__root {
    padding: 0px;
  }
  .v-treeview-node__root > .v-icon {
    color: white;
  }
  .v-list-item {
    padding: 0px;
    i {
      color: white;
    }
	}
	.v-list-group__header {
		padding-left: 0 !important;
	}
	.v-list-item__icon:first-child {
		margin-right: 5px !important;
	}
}
#search_result {
  display: none;
  border-bottom: 1px solid #333740;
}
.list_items {
  background: transparent;
  border: none;
}
.toggle_btn {
  min-width: 0px !important;
  min-height: 0px !important;
  color: white;
  background-color: transparent !important;
}
.status_border {
  width: 100%;
  position: relative;
}
.status_border:before {
  content: '';
  position: absolute;
  right    : 0;
  bottom  : 0;
  height  : 1px;
  width   : 96%;
  border-bottom: 1px solid #3d3d3d;

}
</style>